import { Controller } from '@hotwired/stimulus';
import { createPopper } from '@popperjs/core';
import {
  useTransition, useClickOutside, useHotkeys,
} from 'stimulus-use';

export default class extends Controller {
  static targets = ['trigger', 'content', 'wrapper', 'overlay'];

  static values = {
    isVisible: { type: Boolean, default: false },
  };

  connect() {
    useTransition(this, {
      element: this.contentTarget,
      enterActive: 'ink--transition-slide-down--enter-active',
      enterFrom: 'ink--transition-slide-down--enter-from',
      enterTo: 'ink--transition-slide-down--enter-to',
      leaveActive: 'ink--transition-slide-down--leave-active',
      leaveFrom: 'ink--transition-slide-down--leave-from',
      leaveTo: 'ink--transition-slide-down--leave-to',
      hiddenClass: 'js-is-hidden',
    });

    this.instance = createPopper(this.triggerTarget, this.wrapperTarget, {
      placement: 'bottom-start',
    });

    useClickOutside(this);

    useHotkeys(this, {
      esc: [this.hide],
    });
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.handleKeydown);
  }

  async toggle() {
    await (this.isVisibleValue ? this.hide() : this.show());
  }

  async show() {
    if (this.isVisibleValue) return;

    // Close all other open dropdowns
    document.querySelectorAll('[data-controller="dropdown"]').forEach((element) => {
      if (element !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(element, 'dropdown');
        if (controller && controller.isVisibleValue) {
          controller.hide();
        }
      }
    });

    this.wrapperTarget.style.display = 'block';
    if (this.hasOverlayTarget) this.overlayTarget.classList.add('active');
    this.instance.update();
    await this.enter();
    this.isVisibleValue = true;
    this.contentTarget.focus();
  }

  async hide() {
    if (!this.isVisibleValue) return;

    await this.leave();
    this.isVisibleValue = false;
    this.wrapperTarget.style.display = 'none';
    if (this.hasOverlayTarget) this.overlayTarget.classList.remove('active');
  }

  clickOutside(event) {
    this.hide();
  }
}
